<script setup>
const props = defineProps({
  image: {
    type: Object,
    required: false,
    default: () => ({
      mobile: 'a.hwstatic.com/image/upload/q_auto,f_auto/hw/location-images/type/hostels_s.jpg',
      tablet: 'a.hwstatic.com/image/upload/q_auto,f_auto/hw/location-images/type/hostels_m.jpg',
      desktop: 'a.hwstatic.com/image/upload/q_auto,f_auto/hw/location-images/type/hostels_l.jpg',
    }),
  },
});

const { useImage } = useImages();
const {
  isExtraSmallScreen,
  isSmallOrMediumScreen,
} = useMq();

const DEFAULT_HERO = {
  mobile: 'a.hwstatic.com/image/upload/q_auto,f_auto/hw/location-images/type/hostels_s.jpg',
  tablet: 'a.hwstatic.com/image/upload/q_auto,f_auto/hw/location-images/type/hostels_m.jpg',
  desktop: 'a.hwstatic.com/image/upload/q_auto,f_auto/hw/location-images/type/hostels_l.jpg',
};

// ### COMPUTED
const getHeroPicture = computed(() => {
  const heroImage = props?.image || DEFAULT_HERO;
  const heroImageForViewport = toValue(isExtraSmallScreen)
    ? heroImage?.mobile
    : toValue(isSmallOrMediumScreen)
      ? heroImage?.tablet
      : heroImage?.desktop;

  return heroImageForViewport ? `background-image: url("${useImage.getImage(heroImageForViewport)}")` : null;
});
</script>

<template>
  <div
    class="hero-image"
    :style="getHeroPicture"
  />
</template>

<style lang="scss" scoped>
.hero-image {
  position: relative;
  height: wds-rem(128px);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: $wds-color-ink-lighter;
  border-radius: $wds-border-radius-xl;

  @include tablet {
    height: wds-rem(360px);
  }
}
</style>
